import React, { useState } from 'react';
import { Box, Container, Typography, Tab, Tabs, Paper } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import menuTheme from '../menuTheme';
import PendingInvoices from '../components/moderator/PendingInvoices';
import PendingVerifications from '../components/moderator/PendingVerifications';
import PendingRefunds from '../components/moderator/PendingRefunds';
import UserSearch from '../components/moderator/UserSearch';
import CreateUnclaimedDistributor from '../components/moderator/CreateUnclaimedDistributor';
import withModeratorAuth from '../components/routes/withModeratorAuth';

function TabPanel({ children, value, index }) {
  return (
    <div hidden={value !== index} style={{ marginTop: '20px' }}>
      {value === index && children}
    </div>
  );
}

function ModeratorDashboard() {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <ThemeProvider theme={menuTheme}>
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h4" gutterBottom>
          Panel de Moderación
        </Typography>

        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={tabValue} onChange={handleTabChange}>
            <Tab label="Facturas Pendientes" />
            <Tab label="Verificaciones Pendientes" />
            <Tab label="Reembolsos Pendientes" />
            <Tab label="Buscar Distribuidores" />
            <Tab label="Buscar Negocios" />
            <Tab label="Crear Distribuidor No Reclamado" />
          </Tabs>
        </Box>

        <TabPanel value={tabValue} index={0}>
          <PendingInvoices />
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <PendingVerifications />
        </TabPanel>
        <TabPanel value={tabValue} index={2}>
          <PendingRefunds />
        </TabPanel>
        <TabPanel value={tabValue} index={3}>
          <UserSearch userType="distributors" />
        </TabPanel>
        <TabPanel value={tabValue} index={4}>
          <UserSearch userType="businesses" />
        </TabPanel>
        <TabPanel value={tabValue} index={5}>
          <CreateUnclaimedDistributor />
        </TabPanel>
      </Container>
    </ThemeProvider>
  );
}

export default withModeratorAuth(ModeratorDashboard);